import { Box, Divider, useColorModeValue } from "@chakra-ui/react";
import { TextGray } from "components/Atomos/Texts/TextGray";
import { VersaoPublicada } from "store/modules/consultaprevia/types";

const formatarData = (valor?: string | null) => {
  if (!valor) return null;

  const data = new Date(valor);

  return Number.isNaN(data.getTime())
    ? null
    : data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
};

/**
 * Carimbo da versão que respondeu. Uma consulta prévia sem a versão e a
 * legislação que a fundamentam não serve para instruir processo nenhum.
 */
export const RodapeVersao = ({
  versao
}: {
  versao?: VersaoPublicada | null;
}) => {
  const borderColor = useColorModeValue("gray.100", "gray.800");

  if (!versao) return null;

  const publicacao = formatarData(versao.dataPublicacao);
  const legislacao = formatarData(versao.dataLegislacao);

  return (
    <Box mt="6">
      <Divider borderColor={borderColor} mb="3" />
      <TextGray fontSize="xs">
        {`${versao.nome} — versão ${versao.numeroVersao}`}
      </TextGray>
      {publicacao && (
        <TextGray fontSize="xs">{`Publicada em ${publicacao}`}</TextGray>
      )}
      {versao.numeroLegislacao && (
        <TextGray fontSize="xs">
          {`Legislação ${versao.numeroLegislacao}${
            legislacao ? ` de ${legislacao}` : ""
          }`}
        </TextGray>
      )}
      <TextGray fontSize="xs" mt="2" fontStyle="italic">
        Consulta informativa, sem valor de alvará ou certidão.
      </TextGray>
    </Box>
  );
};
